module.exports = __webpack_public_path__ + "static/img/Rejuvenation-2.3aa756b.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list/Rejuvenation-2.png
// module id = 5DYs
// module chunks = 1